// Module
var code = "<span class=\"sb-process-activity__text\"> {{$ctrl.activity.name | ellipse: 40 }} <md-tooltip> <span>{{$ctrl.activity.getDisplayText()}}</span> </md-tooltip> </span> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/states/processViewer/sbActivityCard/activity_card_progress_layout.prtl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;